import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';


import dayjs from 'dayjs';
import '@helpers/dayjs.setup';
import { HttpService } from '@services/http.service';
import { AvailableStaff, ContractDetail } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class AvailableStaffsService extends HttpService {
    private contractsSubject = new BehaviorSubject<ContractDetail[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { details: ContractDetail[] } = { details: [] };

    readonly details = this.contractsSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    list(idTask: string, filterDate: Date, ianaZone: string): void {
        this.loading(true);
        this.nextDetails([]);
        this.listServices(idTask, filterDate, ianaZone).subscribe(
            () => {
                this.nextDetails([ ...this.dataStore.details ]);
                this.loading(false);
            }
        );
    }

    private listServices(idTask: string, filterDate: Date, ianaZone: string): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                const params = new HttpParams({ fromString: `dateFilter=${dayjs(filterDate).format('YYYY-MM-DD')}` });
                this.get(`customer/services/${idTask}/schedules`, { app: 'member', version: 3 }, params).subscribe(
                    data => {
                        this.dataStore.details = [];

                        data.schedules.forEach((available: any) => {
                            const availableStaff: AvailableStaff = new AvailableStaff().build(available);
                            const details = availableStaff.listContractDetail(ianaZone);
                            details.forEach(detail => this.dataStore.details.push(detail));
                        });

                        this.dataStore.details = this.dataStore.details.sort((a, b) => this.sortHoursAndMinutes(a.startTime, b.startTime));
                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private nextDetails(data: ContractDetail[]): void {
        this.contractsSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }

    private sortHoursAndMinutes(first: Date, second: Date): number {
        const firstHour = dayjs(first).hour();
        const secondHour = dayjs(second).hour();

        if (firstHour > secondHour) {
            return 1;
        }

        if (firstHour < secondHour) {
            return -1;
        }

        const firstMinute = dayjs(first).minute();
        const secondMinute = dayjs(second).minute();

        if (firstMinute > secondMinute) {
            return 1;
        }

        if (firstMinute < secondMinute) {
            return -1;
        }

        return 0;
    }
}
